'use client';

import { useRouter } from 'next/router';
import { Navigation, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import Caret from 'components/Icons/Caret';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { getArmVariationOldSystem } from 'functions/getVariations';
import { frameSizeConst } from 'constants/frameSize';
import { useMemo, useState, useEffect, useRef } from 'react';
import { recommendationArmColor } from 'functions/armRecommendation';
import CartArmRecommended from './CartArmRecommended';
import CartAccessoryRecommended from './CartAccessoryRecommended';
import { getGlassesQuantity } from 'functions/makeDiscount';
import { useGlassesStore } from 'zus/glassesStore';
import { wcApiDataService } from 'functions/wcApi';
import { getArmProductId } from 'constants/woocommerceParentCateoryIds';
import { GET_PRODUCT_BY_ID } from 'gqlStrings/queries/getProduct';
import { handleregionapollo } from 'functions/handleregionapollo';
import { useQueryState } from 'nuqs';

const DEFAULT_MIN_TABLET_VIEWPORT_WIDTH = 768;

const DEFAULT_MIN_VIEWPORT_WIDTH = 1155;
const SWIPER_BREAKPOINTS = Object.freeze({
  [DEFAULT_MIN_VIEWPORT_WIDTH]: {
    slidesPerGroup: 4,
    slidesPerView: 4,
    spaceBetween: 0,
    speed: 1200
  },
  [DEFAULT_MIN_TABLET_VIEWPORT_WIDTH]: {
    slidesPerGroup: 1,
    slidesPerView: 3,
    spaceBetween: 0,
    speed: 200
  }
});

interface CartRecommendedProductsProps {
  shoppingCart: boolean;
  frameColorZ?: string;
}

export default function CartRecommendedProducts({ frameColorZ, shoppingCart }: CartRecommendedProductsProps) {
  const [accessories, setAccessories] = useState<any>(null);
  const [armProducts, setArms] = useState<any>(null);
  const router = useRouter();

  useEffect(() => {
    async function fetchAccessories() {
      const data = await wcApiDataService(
        'cat/accessories',
        'hasProducts&hasSubCategory',
        router.locale
      );
      setAccessories(data);
    }
    async function fetchArms() {
      const arms = await handleregionapollo(router.locale).query({
        query: GET_PRODUCT_BY_ID,
        variables: {
          id: getArmProductId(router.locale),
          idType: 'DATABASE_ID'
        },
        context: { region: router.locale }
      });
      //console.log('fetchArms :', arms.data.product);
      setArms(arms.data.product);
    }

    fetchAccessories();
    fetchArms();
  }, [router.locale]);

  const bagItems = useSelector((state: RootState) => state.bagEvent.bag);
  const [randomState] = useState(Math.random());
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const getRegularSize = (size: string) => {
    var sizeTitle;
    frameSizeConst.forEach((frameSize: any) => {
      if (frameSize.slug === size) {
        sizeTitle = frameSize.title;
      }
    });
    return sizeTitle;
  }
  const getRegularSizeShort = (size: string) => {
    var sizeTitle;
    frameSizeConst.forEach((frameSize: any) => {
      if (frameSize.short === size) {
        sizeTitle = frameSize.title;
      }
    });
    return sizeTitle;
  }

  const isProductInBag = (product: any, type: string) => {
    var isInBag = false;
    if (bagItems.items) {
      for (const item of bagItems.items) {
        if (((type == 'simple' && item[0].databaseId == product.post_id) || (product && 'databaseId' in product && type == 'arm' && item[0].databaseId == product.databaseId))) {
          isInBag = true;
        }
      }
    }

    return isInBag;
  }
	const [armColorQuery] = useQueryState('armColor');

  const arms_size = useGlassesStore((state) => state.arms_size);
  const frame_color = frameColorZ;
  const arms_color = armColorQuery ?? frameColorZ;
  
  const getRecommendedArms = useMemo(() => {
    var variations: any = [];

    var frameColor;
    var armSize: string | undefined;
    var recomemdedColor;
    var arm_variation: any;
    var checkRecomemdedColor = false;
    var checkNumber;

    if ((shoppingCart && bagItems.items && getGlassesQuantity(bagItems.items) > 0) || !shoppingCart) {
      if (shoppingCart) {
        for (const item of bagItems.items) {
          if (item && item[0].type && item[0].type === 'extradata') {
            frameColor = item[0].glassesData.frameColor;
            armSize = getRegularSize(item[0].glassesData.armSize);
            recomemdedColor = recommendationArmColor(frameColor, randomState);
            arm_variation = getArmVariationOldSystem(armProducts, recomemdedColor, armSize!);
            if (isProductInBag(arm_variation, 'arm')) {
              checkRecomemdedColor = true;
              checkNumber = 0;
              while (checkRecomemdedColor && checkNumber < 3) {
                recomemdedColor = recommendationArmColor(frameColor, Math.random());
                arm_variation = getArmVariationOldSystem(armProducts, recomemdedColor, armSize!);
                if (!isProductInBag(arm_variation, 'arm')) {
                  checkRecomemdedColor = false;
                }
                checkNumber++;
              }
            }

            if (checkRecomemdedColor) {
              return [];
            }

            if (arm_variation) {
              variations.push({ ...arm_variation, frame_color: frameColor });
            }
            variations = variations.sort(() => 0.5 - randomState);
            return [...variations.slice(0, 1)];
          }
        }
      } else if(frame_color) {
        recomemdedColor = recommendationArmColor(frame_color, randomState);
        arm_variation = getArmVariationOldSystem(armProducts, recomemdedColor, getRegularSizeShort(arms_size)!);
        if (isProductInBag(arm_variation, 'arm')) {
          checkRecomemdedColor = true;
          checkNumber = 0;
          while (checkRecomemdedColor && checkNumber < 3) {
            recomemdedColor = recommendationArmColor(frame_color, Math.random());
            arm_variation = getArmVariationOldSystem(armProducts, recomemdedColor, armSize!);
            if (!isProductInBag(arm_variation, 'arm')) {
              checkRecomemdedColor = false;
            }
            checkNumber++;
          }
        }
        if (arm_variation) {
          variations.push({ ...arm_variation, frame_color: frameColor });
        }
        variations = variations.sort(() => 0.5 - randomState);
        return [...variations.slice(0, 1)];
      }
    }

    return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [armProducts, bagItems, arms_color, arms_size, frame_color]);

  const getRecommendedAccessories = useMemo(() => {
    // Define accessory categories with their priorities
    const categories = {
      eyeCare: {
        items: [] as any[],
        maxItems: 1,
        priority: 1,
        matcher: (product: any) => product.slug.includes('anti-fog') || product.slug.includes('lens-cleaner') || product.slug.includes('wipes')
      },
      protection: {
        items: [] as any[],
        maxItems: 1,
        priority: 2,
        matcher: (product: any) => product.slug.includes('felt-case') || product.slug.includes('pin-garage')
      },
      style: {
        items: [] as any[],
        maxItems: 1,
        priority: 3,
        matcher: (product: any) => product.slug.includes('glasses-straps') || product.slug.includes('flex-accessory-clip')
      },
      cleaning: {
        items: [] as any[],
        maxItems: 1,
        priority: 4,
        matcher: (product: any) => product.slug.includes('cloth') || product.slug.includes('cleaning')
      }
    };

    if (accessories && bagItems.items && ((shoppingCart && getGlassesQuantity(bagItems.items) > 0) || !shoppingCart)) {
      // First pass: Categorize products
      accessories.products.forEach((product: any) => {
        for (const [category, config] of Object.entries(categories)) {
          if (config.matcher(product) && !isProductInBag(product, 'simple')) {
            config.items.push(product);
          }
        }
      });

      // Second pass: Sort items within each category randomly
      for (const category of Object.values(categories)) {
        category.items.sort(() => 0.5 - randomState);
      }

      // Third pass: Build final recommendations list
      let recommendations: any[] = [];
      const categoryEntries = Object.entries(categories).sort((a, b) => a[1].priority - b[1].priority);
      
      for (const [_, config] of categoryEntries) {
        recommendations = [...recommendations, ...config.items.slice(0, config.maxItems)];
      }

      // If we don't have enough recommendations, add more from any category
      if (recommendations.length < 4) {
        const remainingItems = accessories.products
          .filter((product: any) => 
            !isProductInBag(product, 'simple') && 
            !recommendations.some(rec => rec.post_id === product.post_id))
          .sort(() => 0.5 - randomState);
        
        recommendations = [...recommendations, ...remainingItems.slice(0, 4 - recommendations.length)];
      }

      return recommendations;
    }
    return [];
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessories, bagItems, arms_color, arms_size, frame_color]);

  if (!isVisible || !accessories || !armProducts) {
    return <div ref={sectionRef} className="h-96 bg-gray-100"></div>;
  }

  return (
    <>
      {((shoppingCart && bagItems.items && bagItems.items.length > 0 && getGlassesQuantity(bagItems.items) > 0) || !shoppingCart) && (
        <section ref={sectionRef} className="bg-white py-[40px] px-0 sm:px-4 sm:pt-[88px] sm:pb-[78px]">
          <div className="mx-auto lg:max-w-[1224px]">
            <span className="mb-[22px] block text-center text-[24px] font-semibold text-brand-black100 sm:mb-[30px] md:text-[36px]">
              People Also Bought
            </span>
            <div className="relative mx-auto sm:px-1 lg:max-w-[700px] shop:max-w-[980px] xl:max-w-[1100px] 2xl:max-w-none">
              <Swiper
                className="recommended-products-swiper"
                modules={[Pagination, Navigation]}
                loop={false}
                breakpoints={SWIPER_BREAKPOINTS}
                speed={600}
                navigation={{
                  nextEl: '[data-recommended-products-slider-next]',
                  prevEl: '[data-recommended-products-slider-previous]'
                }}
                slidesPerView={1.5}
                lazy={true}
                spaceBetween={0}
                watchOverflow={true}
                allowTouchMove={true}
                simulateTouch={false}
                /*loopFillGroupWithBlank={true}*/
                slidesPerGroup={1}
                initialSlide={0}
                key={router.locale}
                pagination={{
                  clickable: true,
                  el: '[data-recommended-products-slider-pagination]',
                  bulletClass: 'review-swiper-bullet',
                  bulletActiveClass: '!bg-brand-black100',
                  horizontalClass: 'review-swiper-pagination-horizontal',
                  renderBullet: (_, classList) => {
                    return `<span data-ignore-global-swiper-bullet-style class="review-swiper-bullet cursor-pointer transition-all duration-200 h-[10px] w-[10px] !m-[4px] rounded-full bg-brand-grey500 ${classList}"></span>`;
                  }
                }}>

                {getRecommendedArms.map((product: any) => (
                  <SwiperSlide className="!h-auto" key={product.databaseId}>
                    <div className="h-full sm:p-[10px]">
                      <CartArmRecommended product={product} />
                    </div>
                  </SwiperSlide>
                ))}

                {getRecommendedAccessories.map((product: any) => (
                  <SwiperSlide className="!h-auto" key={product.post_id}>
                    <div className="h-full sm:p-[10px]">
                      <CartAccessoryRecommended product={product} />
                    </div>
                  </SwiperSlide>
                ))}

              </Swiper>
              <div
                data-recommended-products-slider-pagination
                className="mx-auto mt-[30px] flex flex-wrap justify-center"></div>
              <div
                data-recommended-products-slider-previous
                className="transition-color absolute left-[-68px] top-[160px] z-10 hidden h-[42px] w-[42px] rotate-90 transform cursor-pointer items-center justify-center rounded-full bg-white text-brand-black100 shadow-card duration-500 hover:text-brand-orange lg:flex">
                <Caret className="mt-[3px]" fill="currentColor" />
              </div>
              <div
                data-recommended-products-slider-next
                className="rotate absolute right-[-68px] top-[160px] hidden h-[42px] w-[42px]  -rotate-90 transform cursor-pointer items-center justify-center rounded-full bg-white text-brand-black100 shadow-card duration-500 hover:text-brand-orange lg:flex">
                <Caret className="mt-[3px]" fill="currentColor" />
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};
